<template>
<div>
   <h-header title="课程列表" btnText="创建课程" @btnFuc="showCreateBox" @loginSuccess="loginSuccess"></h-header>
   <div class="main-content">
       <div class="class-lab" v-for="(item,index) in classList">
           <div class="pic-box">
               <img v-if="item.img" :src="splitUrl(item.img)">
               <img v-else src="../assets/images/class.jpg">
               <div class="btn-active">
                   {{judgeStatusShow(item.status,1)}}
                </div>
           </div>
           <div class="middle">
               <div class="title">{{item.title}}</div>
               <div class="class-details">
                   <i class="iconfont iconjijiangdaozhang"></i>
                   {{getClassTime(item.start_time,item.duration)}} | 授课{{item.duration}}分钟 |  {{item.audience_size}}人报名
               </div>
           </div>
           <div class="bottom">
               <div class="btn left-btn hover" @click="shareLink(item)">查看链接</div>
               <div class="btn right-btn hover" @click="openWindow('ClassInfo',{'id':item.id,'token':item.token})">进入课程</div>
           </div>
       </div>
   </div>
   <!-- v-if="linkShow" @click="linkShow=false" -->
   <share-link v-if="linkShow"
    :url="linkObj.url"
    @closeShareLink="linkShow=false"
   ></share-link>
   <h-footer></h-footer>
</div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import ShareLink from '../components/ShareLink';
export default {
    name:'AdminRoom',
    data(){
        return{
            classList:[],
            createShow:false,
            linkShow:false,
            linkObj:{
                url:'',
                secret:''
            },
            pageSize:15,
            currentPage:1
        }
    },
    components:{
        'h-header':Header,
        'h-footer':Footer,
        'share-link':ShareLink
    },
    created(){
        
    },
    activated(){
        
    },
    methods:{
        loginSuccess(){
            if(this.classList.length == 0){
                this.currentPage = 1
                this.classList = []
                this.getClassList()
            }
        },
        getClassList(){
            let that = this
            this.$post(this,{
                url:'getClassList',
                data:{
                    type:1,//1:自己创建的列表，2:参与的列表
                    pageSize:that.pageSize,
                    currentPage:that.currentPage
                },
                success(data){
                    for(let i = 0,lg = data.records.length;i < lg;i++){
                        let obj = data.records[i]
                        that.classList.push(obj)
                    }
                    if(data.allCount > that.classList.length){
                        that.currentPage++
                        that.getClassList()
                    }
                }
            })
        },
        showCreateBox(){
            this.openWindow('CreateClass')
        },
        shareLink(item){
            this.linkShow = true
            this.linkObj.url = 'id='+item.id+'&token='+item.token
            this.linkObj.token = item.token
        }
    },
    computed:{
        refresh(){
            return this.$store.state.reClassList
        }
    },
    watch:{
        refresh(){
            this.currentPage = 1
            this.classList = []
            this.getClassList()
        }
    }
}
</script>
<style scoped>
.up-img-show{
    position:absolute;
    width:100%;
    height: 100%;
    top: 0;
    left: 0;
}
.main-content{
    display: flex;
    flex-wrap: wrap;
    width:1170px;
    margin:0 auto;
}
.main-content .class-lab{
    width:370px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(229, 229, 229, 1);
    border-radius:5px;
    overflow: hidden;
    margin-bottom: 50px;
    margin-right: 30px;
}
.main-content .class-lab:nth-child(3n){
    margin-right: 0;
}
.main-content .pic-box{
    position:relative;
    width:370px;
    height:250px;
}
.main-content .pic-box img{
    width:100%;
    height: 100%;
}
.main-content .pic-box .btn-active{
    position:absolute;
    width:50px;
    height:50px;
    line-height: 50px;
    background:#5fbe96;
    box-shadow:0px 2px 10px 0px rgba(38,38,38,0.15);
    border-radius:50%;
    top: 5px;
    left: 5px;
    font-size: 14px;
    color: #fff;
}
.main-content .pic-box .over{
    background: #999999;
}
.main-content .pic-box .wait{
    background:  #75a0c9;
}
.main-content .middle{
    width:100%;
    text-align: left;
    padding:0 30px;
    border-bottom: 1px solid #CDCDCD;
}
.main-content .middle .title{
    line-height: 20px;
    font-size: 16px;
    padding:10px 0 8px 0;
    font-weight: bold;
    color: #262626;
    white-space: nowrap; 
    width: 100%; 
    overflow: hidden;
    text-overflow:ellipsis;
}
.main-content .middle .class-details{
    font-size: 14px;
    color: #333;
    padding-bottom: 16px;
}
.main-content .middle .class-details .iconfont{
    font-size: 20px;
    color: #333;
    vertical-align: middle;
}
.main-content .bottom{
    display: flex;
    justify-content: space-around;
}
.main-content .bottom .btn{
    width:145px;
    height:34px;
    line-height: 34px;
    font-size: 16px;
    border-radius:5px;
    margin:20px 0;
}
.main-content .bottom .left-btn{
    border:1px solid rgba(153,153,153,1);
}
.main-content .bottom .right-btn{
    background:rgba(95,190,150,1);
    color: #fff;
}

.mask{
    position:absolute;
    width:100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(72,89,111,0.4);
}
.mask .create-class-box{
    width:800px;
    background: #596E88;
    margin:20px auto 0 auto;
    font-size: 18px;
    padding:27px 58px 30px;
}
.create-class-box .title{
    font-size: 20px;
    margin-bottom: 20px;
    color: #fff;
}
.create-class-box .tit{
    color: #fff;
}
.create-class-box .ivu-row{
    margin-bottom: 20px;
}
.create-class-box .ivu-radio-wrapper{
    font-size: 20px;
    color:#fff;
}
.create-class-box .btn{
    width:259px;
    height:40px;
    line-height: 40px;
    background:rgba(105,195,125,1);
    border-radius:20px;
    text-align: center;
    margin:0 auto;
    color: #fff;
}

</style>